import { useState } from "react";
import Link from "next/link";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import CarouselNavArrow from "@components/Icons/CarouselNavArrow";
import getConfig from "next/config";
const {
  publicRuntimeConfig: { settings },
} = getConfig();

const Banners = ({ items }) => {
  const [prevEl, setPrevEl] = useState(null);
  const [nextEl, setNextEl] = useState(null);

  return (
    <div className="w-full h-auto">
      {items && items.length !== 0 && (
        <div className="relative">
          <Swiper
            className="lg:rounded-br-2xl bg-red-brand"
            slidesPerView={1}
            spaceBetween={0}
            loop={true}
            pagination={{
              clickable: true,
            }}
            autoplay={{
              delay: 3500,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            navigation={{
              nextEl,
              prevEl,
            }}
            modules={[Autoplay, Pagination, Navigation]}
          >
            {items.map((item, index) => {
              return (
                <SwiperSlide key={index}>
                  <Link href={item.link}>
                    <a
                      className="flex justify-center"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={`${settings.cdn}${item.file}`} alt="" />
                    </a>
                  </Link>
                </SwiperSlide>
              );
            })}
          </Swiper>

          <div className="hidden md:flex absolute top-0 left-0 ml-8 h-full items-center ">
            <div
              className="w-7 h-7 lg:w-8 lg:h-8 bg-white opacity-90 lg:opacity-60 rounded-full cursor-pointer z-10"
              ref={(node) => setPrevEl(node)}
            >
              <CarouselNavArrow direction="left" />
            </div>
          </div>

          <div className="hidden md:flex absolute top-0 right-0 mr-8 h-full items-center">
            <div
              className="w-7 h-7 lg:w-8 lg:h-8 bg-white opacity-90 lg:opacity-60 rounded-full cursor-pointer z-10"
              ref={(node) => setNextEl(node)}
            >
              <CarouselNavArrow direction="right" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Banners;
